/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import Button from '@material-ui/core/Button';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import AddNewBuildingForm from './AddNewBuildingForm';
import AddNewBuildingSuccess from './AddNewBuildingSuccess';
import Form from '../../../../../forms/_.extend';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
  config: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewBuilding extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore, config }: TypeProps = this.props;
    const fields: Array<Object> = [
      {
        name: 'addBuildingForm',
        label: t('general:new_building'),
        title: 'New Building',
        fields: [
          {
            name: 'tradingAccount',
            label: t('general:trading_account'),
            rules: 'required|string',
            disabled: true,
            value: this.props.params.id,
          },
          {
            name: 'company',
            label: t('general:company'),
            rules: 'required|string',
            disabled: true,
            value: config.companyId,
          },
          {
            name: 'site',
            label: t('general:locations.labels.site'),
            rules: 'required|string',
            disabled: true,
            value: config.siteId,
          },
          {
            name: 'buildingName',
            label: t('general:locations.labels.building_transport'),
            rules: 'required|string',
            value: '',
          },
          {
            name: 'contactPhoneNo',
            label: t('general:labels.contact_phone_number'),
            rules: 'telephone',
            value: '',
          },
          {
            name: 'contactFaxNo',
            label: t('general:labels.contact_fax_number'),
            rules: 'telephone',
            value: '',
          },
          {
            name: 'locationContact',
            label: t('general:locations.labels.contact'),
            rules: 'string',
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const {
          company,
          site,
          buildingName,
          contactPhoneNo,
          contactFaxNo,
          locationContact,
        }: Object = data.values().addBuildingForm;

        actionDrawerStore.userAddLocation({
          parent_id: site,
          company_id: company,
          name: buildingName,
          country_id: config.countryId,
          contact: locationContact,
          contact_phone: contactPhoneNo,
          contact_fax: contactFaxNo,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: t('general:new_building'),
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore, config }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.create_new_building')} />
          <div className={styles['action-drawer-content']}>
            {actionDrawerStore.errorResponse.message}
          </div>
          <div className={styles['action-drawer-actions']}>
            <Button
              color="primary"
              variant="contained"
              onClick={() => actionDrawerStore.closeActionDrawer()}
            >
              {t('general:actions.close')}
            </Button>
          </div>
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return <AddNewBuildingSuccess config={config} />;
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.create_new_building')} />
        <AddNewBuildingForm form={this.createForm()} />
      </div>
    );
  }
}
